import React, { useState } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';

import { useNavigate } from 'react-router-dom';
import PolicyDetailForm from './PolicyDetailForm';
import Styles from './grouppolicyStyle.module.scss';
import ProgressBar from '../../components/ProgressBar/progressbar';
import { useParams } from 'react-router-dom';

const CreatePolicy = () => {
  const { id } = useParams();
  const isEditMode = Boolean(id);
  const navigate = useNavigate();

  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className=" flex-1" style={{ backgroundColor: 'rgb(7, 7, 7)' }}>
        <Header title="Group Policy Automation" dropdown={2} />

        <Card className="flex-1">
          <div className={`${Styles.progressBar} items-center justify-between mb-0`}>
            <ProgressBar stepNum={1} identity={'Automation'} />
          </div>
          <PolicyDetailForm policyId={id} isEditMode={isEditMode} />
        </Card>
      </div>
    </div>
  );
};

export default CreatePolicy;
